'use client';

interface FilterBarProps {
  categories: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

const FilterBar = ({ categories, activeFilter, onFilterChange }: FilterBarProps) => {
  return (
    <div className="flex flex-wrap gap-3 lg:gap-4">
    </div>
  );
};

export default FilterBar;